<template>
  <div class="EnterEmailView container">
    <div class="mb-24 grid col-1 lg-col-2 pb-40">
      <div class="EnterEmailView__left lg-pr-112">
        <template v-if="productionTip">
          <div>
            <img
              v-if="productionTip.Image"
              class="w-full hide md-d-block"
              :src="`${productionTip.Image.data.attributes.url}`"
              alt="Production tip image"
            />
            <div class="hide lg-d-block">
              <h2 class="font-family-display font-weight-bold mb-24">
                {{ productionTip.Title }}
              </h2>
              <p>{{ productionTip.Text }}</p>
            </div>
          </div>
        </template>
      </div>
      <div class="EnterEmailView__right pt-40 md-pt-0">
        <div>
          <h1 class="font-family-display font-weight-bold mb-8">
            {{ $t('reset_your_password') }}
          </h1>
          <p class="mb-24">
            {{ $t('enter_your_email_address') }}
            <router-link :to="{ name: 'Login' }">
              {{ $t('back_to_login') }}
            </router-link>
          </p>

          <form
            class="flex flex-col items-center"
            novalidate="true"
            @submit.prevent="sendRecoverEmail"
          >
            <InputField
              id="email"
              v-model="email"
              type="text"
              left-icon-class="icon-mail-envelope"
              right-icon-class="icon-close input__right-icon--hover"
              :label="$t('email')"
              :has-error="v$.email.$invalid && v$.email.$anyDirty"
              :has-right-reset-button="true"
              @on-right-click="email = ''"
            />

            <button
              class="btn btn--purple"
              :class="{ 'btn--loading': loading }"
              :disabled="v$.$invalid || loading"
              type="submit"
            >
              <template v-if="loading">
                <LoadingDots />
              </template>
              <template v-else>
                {{ $t('recover') }}
                <span class="icon-simple-arrow-right btn__icon"></span>
              </template>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { InputField } from '@snowshoe-frontend/form-fields-components'
import { LoadingDots } from '@snowshoe-frontend/shared-components'
import useVuelidate from '@vuelidate/core'
import { required, email as emailValidator } from '@vuelidate/validators'
import recoverPassServices from '../../api/services/recoverPassServices'
import { storeToRefs } from 'pinia'
import { useChangePasswordStore } from '@/stores/changePasswordStore'
import { useCmsStore } from '@/stores/cmsStore'
import { useRouter } from 'vue-router'
import { useNotificationsStore } from '@/stores/notificationsStore'

const email = ref('')
const loading = ref(false)

const router = useRouter()

const cmsStore = useCmsStore()
const { setNotification } = useNotificationsStore()
const { setHasSentLinkSuccess } = useChangePasswordStore()
const { productionTip } = storeToRefs(cmsStore)

const rules = {
  email: {
    required,
    email: emailValidator
  }
}

const v$ = useVuelidate(rules, { email })

async function sendRecoverEmail() {
  try {
    loading.value = true
    await recoverPassServices.postReset(email.value)
    setHasSentLinkSuccess(true)
    await router.push({ name: 'PasswordResetCheckEmailView' })
  } catch (e) {
    setNotification({
      header: e.message,
      body: 'An error occurred',
      type: 'danger'
    })
  } finally {
    loading.value = false
  }
}
</script>

<style lang="scss" scoped>
.EnterEmailView {
  margin-top: 100px;
  margin-bottom: 0;
}
</style>
